import type { SiteEntity } from '../../types/site';
import type { SiteEvidenceDocument } from '../../types/siteEvidence';
import type { SiteRagReport } from '../../types/siteRag';
import { reportContentRevisionReferenceV1Schema } from '../../types/reportContent';
import {
  buildCurrentCustomBriefReportContentInputV1,
  hashReportContentInputV1,
  reportContentInputsCurrent,
} from '../reportContent/identity';

/** Project live input currency from the same frozen owner input used by the
 * producer. The server still authorizes exports against its current pointer;
 * this pure UI check cannot substitute for that transactional boundary. */
export function customBriefContentMatchesCurrentInputs(
  report: SiteRagReport,
  site: SiteEntity,
  sed: SiteEvidenceDocument | null,
): boolean {
  // Older unstamped Briefs retain their existing SED/intent/source-frame rules.
  if (report.reportType !== 'custom-brief' || report.reportContentRevision === undefined) return true;
  try {
    const reference = reportContentRevisionReferenceV1Schema.parse(report.reportContentRevision);
    const frozenInput = report.reportContentInputAtGen;
    const revision = report.reportRevision;
    if (!frozenInput || !sed || !revision
      || reference.siteId !== site.id || report.siteId !== site.id
      || sed.id !== site.sedId || sed.version !== site.sedVersion
      || reference.reportId !== report.id || reference.reportRevisionId !== revision.revisionId
      || reference.contentHash !== revision.documentHash
      || !reference.readiness.current || !reference.readiness.ready
      || !reference.readiness.canCreateExport || reference.readiness.state !== 'ready'
      || hashReportContentInputV1(frozenInput) !== reference.inputHash) return false;
    return reportContentInputsCurrent(frozenInput, buildCurrentCustomBriefReportContentInputV1({
      site, sed, frozenInput,
    }));
  } catch {
    return false;
  }
}
